import type { PropsWithChildren, FC } from 'react';

import { arrowClass, errorContainerClass } from './InputError.css';
import { Text } from '../Text/Text';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';

interface Props {
  id?: string;
  children: string;
  hasArrow?: boolean;
  /** Optional additional CSS class */
  className?: string;
}

/** Arrow indicator for error message (roughly 12×6px) */
export const Arrow: FC = () => <div className={arrowClass} />;

Arrow.displayName = 'Arrow';

/** Internal use only (InputText, InputTelephone, etc.) */
export const Error: FC<PropsWithChildren<Props>> = ({
  id,
  children,
  hasArrow = true,
  className,
}) => {
  const endsWithPunctuation = /[.?!]$/.test(children);

  return (
    <div className={className}>
      {hasArrow && <Arrow />}
      <div className={errorContainerClass} id={id} role="alert">
        <Text color="textInverted" size="BodyS">
          {children}
          {endsWithPunctuation ? null : <VisuallyHidden>{'.'}</VisuallyHidden>}
        </Text>
      </div>
    </div>
  );
};
